<template>
    <div class="distribution">
        <div class="distribution_title">
            <p>涨跌分布图</p>
            <div class="distribution_chart_select">
                <p>持股周期 :</p>
                <select class="chary_select" v-model="selectedDay" @click="charySelect">
                    <option :value="item" v-for="(item, key, index) in dayselect" :key="key">{{ item }} 天</option>
                </select>
            </div>
        </div>
        <div class="distribution_main">
            <div ref="chartRef" style="width: 475px; height: 250px; margin: 10px auto 0 auto; border: 1px solid #d6d6d6;"></div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import _ from 'lodash'

    let chart = null
    export default {
        data () {
            return {
                selectedDay: '',
                chartKeyMap: {
                    'lt-7.5': {
                        name: '涨跌幅：小于-7.5%',
                        color: '#259b24'
                    },
                    'egt-7.5&lt-3.5': {
                        name: '涨跌幅：-3.5%到-7.5%',
                        color: '#42bd41'
                    },
                    'egt-3.5&lt0': {
                        name: '涨跌幅：-3.5%到0%',
                        color: '#72d572'
                    },
                    'egt0&lt3.5': {
                        name: '涨跌幅：0%到3.5%',
                        color: '#f36c60'
                    },
                    'egt3.5&lt7.5': {
                        name: '涨跌幅：3.5%到7.5%',
                        color: '#e93f43'
                    },
                    'egt7.5': {
                        name: '涨跌幅：大于7.5%',
                        color: '#d01716'
                    }
                }
            }
        },
        props: {
            dayselect: {
                type: Array,
                required: true
            },
            chartday: {
                type: String,
                required: true
            },
            backtestData: {
                type: Array,
                required: true
            },
            refresh: Boolean
        },
        computed: {
            chartSeriesData () {
                var self = this
                let singleBacktestdata = _.find(this.backtestData, function (item) {
                    return item.daySaleStrategy === Number(self.selectedDay)
                })
                let ordinaryRateGroup = {
                    'egt-3.5&lt0': 0,
                    'egt-7.5&lt-3.5': 0,
                    'egt0&lt3.5': 0,
                    'egt3.5&lt7.5': 0,
                    'egt7.5': 0,
                    'lt-7.5': 0
                }
                if (singleBacktestdata !== undefined) {
                    ordinaryRateGroup = singleBacktestdata.changeRateGroup
                }
                let result = []
                for (let key in ordinaryRateGroup) {
                    result.push({
                        name: this.chartKeyMap[key].name,
                        value: ordinaryRateGroup[key],
                        itemStyle: {
                            color: this.chartKeyMap[key].color
                        }
                    })
                }
                return result
            },
            chartOptions () {
                return {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    series: [{
                        name: '占比次数',
                        type: 'pie',
                        radius: ['0', '60%'],
                        center: ['50%', '50%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderWidth: 0
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: this.chartSeriesData
                    }]
                }
            },
            buriedPoint () {
                return this.$buriedPoint.backtestOnce.upsDownsChart
            }
        },
        methods: {
            charySelect () {
                window.TA.log(this.buriedPoint.cycleOption)
            },
            renderChart () {
                if (chart) {
                    chart.dispose()
                    chart = null
                }

                chart = echarts.init(this.$refs.chartRef)
                chart.setOption(this.chartOptions)
            }
        },
        mounted () {
            this.renderChart()
        },
        created () {
            this.selectedDay = this.chartday
        },
        watch: {
            selectedDay () {
                chart.setOption({
                    series: [{
                        data: this.chartSeriesData
                    }]
                })
            },
            chartOptions () {
                this.renderChart()
            },
            chartday (val) {
                this.selectedDay = val
            },
            refresh () {
                this.selectedDay = this.chartday
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/backtest/main.scss';
</style>


// WEBPACK FOOTER //
// src/components/backtest/chart.vue